import {match} from 'ts-pattern';

import type {RentalCalendarFilterValues} from '../types/RentalCalendarFilterValues';

/**
 * Applies one filter change and drops the selections that change invalidates. Catalogue options are
 * scoped by vehicle type and models by make (see `useRentalCalendarFilterOptions`), so a kept value
 * would go on filtering the calendar while no longer appearing in its own option list.
 */
export function setRentalCalendarFilter(
  filters: RentalCalendarFilterValues,
  key: keyof RentalCalendarFilterValues,
  values: string[]
): RentalCalendarFilterValues {
  const newFilters = {...filters, [key]: values};

  return match(key)
    .with('vehicleType', () => ({...newFilters, ...EMPTY_CATALOGUE_SCOPED_FILTERS}))
    .with('make', () => ({...newFilters, modelFamily: []}))
    .otherwise(() => newFilters);
}

/** Every filter whose options `useVehicleCatalogue` / `useVehicleMake` derive from the vehicle type */
const EMPTY_CATALOGUE_SCOPED_FILTERS = {
  make: [],
  modelFamily: [],
  bodyStyle: [],
  fuelType: [],
  transmission: [],
  drive: [],
  doorCount: [],
  seatCount: [],
} satisfies Partial<RentalCalendarFilterValues>;
